import React, { useEffect, useState } from "react";
import "../assets/css/cibil.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { cibilTable } from "../assets/data/cibilTable";
import Loading from "../components/Loading";
import { getToken } from "../slice/tokenSlice";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Cibil = () => {
  const { url } = useSelector((state) => state.user);
  const { token } = useSelector((state) => state.token);
  const dispatch = useDispatch();

  const [inputs, setInputs] = useState({
    name: "",
    mobile: "",
    pan: "",
    gender: "",
    password: "",
  });
  const [errors, setErrors] = useState({
    name: "",
    mobile: "",
    pan: "",
    gender: "",
    password: "",
  });
  const handleInputs = (e) => {
    const { name, value } = e.target;
    setInputs({
      ...inputs,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("No data found");
  const [show, setShow] = useState(false);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [score, setScore] = useState("");

  const handleSubmit = async () => {
    let newErrors = {};
    if (!inputs.name.trim()) {
      newErrors.name = "Name is required";
    }
    if (!inputs.mobile.trim()) {
      newErrors.mobile = "mobile number is required";
    } else if (!/^\d{10}$/.test(inputs.mobile)) {
      newErrors.mobile = "mobile number must be 10 digits";
    }
    if (!inputs.pan.trim()) {
      newErrors.pan = "PAN is required";
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(inputs.pan.toUpperCase())) {
      newErrors.pan = "Invalid PAN format (e.g., ABCDE1234F)";
    }
    if (!inputs.gender.trim()) {
      newErrors.gender = "Gender is required";
    }
    if (!inputs.password.trim()) {
      newErrors.password = "Password is required";
    } else if (inputs.password !== "SingleDebt@123#") {
      newErrors.password = "Invalid password";
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    } else {
      try {
        const res1 = await axios.get(
          `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Leads/search?criteria=((Phone_Number:equals:${inputs.mobile}))`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Zoho-oauthtoken ${token}`,
            },
          }
        );
        if (res1.status === 204) {
          window.alert("Invalid mobile number");
        } else if (res1.status === 200) {
          if (res1.data.data[0].CIBIL_Check === false) {
            const data = {
              name: inputs.name,
              mobile: inputs.mobile,
              pan: inputs.pan,
              gender: inputs.gender,
            };
            const res2 = await axios.post(`${url}/cibil`, data, {
              "Content-Type": "application/json",
            });
            if (res2.data.status_code === 200 && res2.data.success === true) {
              const cibilScore = res2.data.data.credit_score;
              setScore(cibilScore);
              const cibilData = res2.data.data.credit_report[0].accounts;
              setData1(cibilData);
              setData2(cibilData);
              filterDataForZoho(res1.data.data[0].id, cibilScore, cibilData);
            } else if (
              res2.data.status_code === 422 &&
              res2.data.success === false
            ) {
              window.alert("Wrong PAN card number");
            }
          } else {
            const res3 = await axios.get(
              `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Leads/${res1.data.data[0].id}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Zoho-oauthtoken ${token}`,
                },
              }
            );
            setScore(res3.data.data[0].Credit_Score);
            setData1(res3.data.data[0].Cibil_And_Loan_Details);
            setData2(res3.data.data[0].Cibil_And_Loan_Details);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
        setShow(true);
      }
    }
  };
  const filterDataForZoho = async (id, cibilScore, cibilData) => {
    const allowedFields = [
      "memberShortName",
      "accountType",
      "accountNumber",
      "dateOpened",
      "highCreditAmount",
      "currentBalance",
      "amountOverdue",
      "actualPaymentAmount",
      "emiAmount",
    ];
    const filtered = cibilData.map((item) => {
      return Object.fromEntries(
        allowedFields.map((field) => [field, item[field]])
      );
    });
    const data = [
      {
        id,
        Credit_Score: cibilScore,
        Cibil_And_Loan_Details: filtered,
        CIBIL_Check: true,
      },
    ];
    await axios.put(
      `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Leads`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Zoho-oauthtoken ${token}`,
        },
      }
    );
  };
  //
  const [filterInputs, setFilterInputs] = useState({
    status: "",
    entries: "All",
  });
  const handleFilterInputs = (e) => {
    const { name, value } = e.target;
    setFilterInputs({
      ...filterInputs,
      [name]: value,
    });
  };
  const filterData = () => {
    const filtered = data1.filter((item) => {
      const statusFilter = filterInputs.status?.toLowerCase();
      const matchesStatus =
        !statusFilter ||
        (statusFilter === "active" && item.currentBalance > 0) ||
        (statusFilter === "closed" && item.currentBalance <= 0);

      return matchesStatus;
    });
    setData2(filtered);
  };
  useEffect(() => {
    filterData();
  }, [filterInputs]);
  const resetFilter = () => {
    setFilterInputs({
      status: "",
      entries: "All",
    });
    setData2(data1);
  };
  //
  const formatCurrency = (amount) =>
    amount && !isNaN(amount)
      ? `Rs ${Number(amount).toLocaleString("en-IN")}`
      : "0";
  //
  useEffect(() => {
    dispatch(getToken());
  }, []);

  return (
    <>
      <div className="cibil-container">
        <div className="container">
          <h1 className="head">SingleDebt CIBIL Report Form</h1>

          <div className="cibil-form">
            <h2 className="mb-3">Enter your details</h2>
            <div className="mb-3">
              <div className="form-control">
                <input
                  type="text"
                  name="name"
                  className="form-input"
                  placeholder="name"
                  required
                  autoComplete="off"
                  value={inputs.name}
                  onChange={handleInputs}
                />
                <label htmlFor="name" className="form-label input-label">
                  First Name
                </label>
              </div>
              <p className="text-danger">{errors.name}</p>
            </div>
            <div className="mb-3">
              <div className="form-control">
                <input
                  type="tel"
                  name="mobile"
                  className="form-input"
                  placeholder="mobile"
                  required
                  autoComplete="off"
                  value={inputs.mobile}
                  onChange={handleInputs}
                />
                <label htmlFor="mobile" className="form-label input-label">
                  mobile number
                </label>
              </div>
              <p className="text-danger">{errors.mobile}</p>
            </div>
            <div className="mb-3">
              <div className="form-control">
                <input
                  type="text"
                  name="pan"
                  className="form-input"
                  placeholder="pan"
                  required
                  autoComplete="off"
                  value={inputs.pan}
                  onChange={handleInputs}
                />
                <label htmlFor="pan" className="form-label input-label">
                  PAN Card number
                </label>
              </div>
              <p className="text-danger">{errors.pan}</p>
            </div>
            <div className="mb-3">
              <div className="form-control">
                <select
                  name="gender"
                  className="form-input"
                  required
                  autoComplete="off"
                  value={inputs.gender}
                  onChange={handleInputs}
                >
                  <option value="">Please select</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>
              <p className="text-danger">{errors.gender}</p>
            </div>
            <div className="password-field mb-3">
              <div className="form-control">
                <input
                  type={showPassword === true ? "text" : "password"}
                  name="password"
                  className="form-input"
                  placeholder="password"
                  required
                  autoComplete="off"
                  value={inputs.password}
                  onChange={handleInputs}
                />
                <label htmlFor="password" className="form-label input-label">
                  Password
                </label>
              </div>
              <p className="text-danger">{errors.password}</p>
              <div
                className="password-button"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword === true ? <FaEye /> : <FaEyeSlash />}
              </div>
            </div>
            <div className="text-center">
              <button className="button" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>

        {show === true && (
          <div className="container mt-2">
            {loading === true ? (
              <div className="mb-4">
                <Loading />
              </div>
            ) : (
              <>
                {data1.length !== 0 ? (
                  <>
                    <h1 className="text-center mb-4">
                      Your CIBIL Score: {score}
                    </h1>
                    <h2 className="mb-4">CIBIL Report Summary</h2>

                    <div className="filter">
                      <div>
                        <label>Filter by Account Status</label>
                        <select
                          className="input"
                          name="status"
                          value={filterInputs.status}
                          onChange={handleFilterInputs}
                        >
                          <option value="">Please select</option>
                          <option value="active">Active</option>
                          <option value="closed">Closed</option>
                        </select>
                      </div>
                      <div>
                        <label>Show Entries</label>
                        <select
                          className="input"
                          name="entries"
                          value={filterInputs.entries}
                          onChange={handleFilterInputs}
                        >
                          <option value="10">10</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="All">All</option>
                        </select>
                      </div>
                      <button className="button w-100" onClick={resetFilter}>
                        Reset Filter
                      </button>
                    </div>

                    <div className="table-responsive mt-4">
                      <table className="table table-bordered table-hover table-striped cibil-table">
                        <thead>
                          <tr>
                            {cibilTable.map((item, index) => {
                              return <th key={index}>{item}</th>;
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {data2
                            .slice(
                              0,
                              filterInputs.entries === "All"
                                ? data1.length
                                : filterInputs.entries
                            )
                            .map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{item.memberShortName || ""}</td>
                                  <td>{item.accountNumber || ""}</td>
                                  <td>
                                    {item.actualPaymentAmount.toString() ===
                                    "-1"
                                      ? 0
                                      : formatCurrency(
                                          item.actualPaymentAmount
                                        )}
                                  </td>
                                  <td>
                                    {formatCurrency(item.highCreditAmount)}
                                  </td>
                                  <td>
                                    {item.dateOpened &&
                                      item.dateOpened
                                        .split("-")
                                        .reverse()
                                        .join("-")}
                                  </td>
                                  <td>{formatCurrency(item.currentBalance)}</td>
                                  <td>
                                    {item.amountOverdue.toString() === "-1"
                                      ? 0
                                      : formatCurrency(item.amountOverdue)}
                                  </td>
                                  <td>{item.accountType || ""}</td>
                                  <td>
                                    {item.emiAmount.toString() === "-1"
                                      ? 0
                                      : formatCurrency(item.emiAmount)}
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </>
                ) : (
                  <p className="text-center py-2">{message}</p>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Cibil;
